export default __webpack_public_path__ + "static/whoosh-and-cityair-launched-kick-scooters-with-air-quality-sensors-d8e7749ff9867454261007c4e28efc96.jpg";